<template>
  <div class="ny">
    <div class="main">
      <div class="ny_bt1 mh md40">
        <span class="bt left">帮助中心</span>
      </div>
      <h2 class="mh md20 sbt">{{de_data.Title}}</h2>
      <div class="mh md30 fbt">{{de_data.AddTime}}</div>
      <div class="mh snr md50">
        {{de_data.Content}}
      </div>
         <div class="suc_anq mh">
        <el-button type="primary" @click="$router.back(-1)">返回</el-button>
      </div>
      <div class="clear"></div>
    </div>
  </div>
</template>

<script>
import http from "../http/http";
import api from "../http/api";
export default {
  data() {
    return {
de_data:[],
    };
  },
      mounted() {
    //加载详细
    this.DetailData();
  },
  methods: {
   //详细
  DetailData: async function () {
      let params = {
        HelpId:this.$route.query.HelpId ,
      }
      const res = await http.get(api.apigethelpdetail, params)
      //  console.log(res.data.obj);
      this.de_data=res.data.obj;
    },
   },
  created: function () {
    // this.$emit('header', false);
  },

};
</script>

<style scoped>
</style>


// WEBPACK FOOTER //
// src/page/help_info.vue